export default __webpack_public_path__ + "static/media/goopter-ecommerce-branded-online-ordering.338346c0.jpg";